import { combineReducers } from "redux";
import logIn from "./Login/reducer";
import otp from "./Otp/reducer";
import donor from "./donorDetails/reducer";
import myDonations from "./myDonations/reducer";
import student from "../redux/studentDetails/reducer";
import Examination from "./examination/reducer";
import getDetailsReducer from "./examdashboard/reducer";
import getschoolreducer from "./createteam/reducer";

export default combineReducers({
  logIn,
  otp,
  donor,
  myDonations,
  student,
  Examination,
  getDetailsReducer,
  getschoolreducer,
});
